import { render } from "./oneself.vue?vue&type=template&id=33a6febd"
import script from "./oneself.vue?vue&type=script&lang=js"
export * from "./oneself.vue?vue&type=script&lang=js"

import exportComponent from "C:\\src\\web\\finance\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__